
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cleanTechnologiesPaginatedS, technologyIsLoadingFinish } from "../../app/actions/technologyActions";
import { cleanVisionsPaginatedS, visionIsLoadingFinish } from "../../app/actions/visionActions";
import { cleanAlternativesPaginatedS, alternativeIsLoadingFinish } from "../../app/actions/alternativeActions";
import { cleanAssistancesPaginatedS, assistanceIsLoadingFinish } from "../../app/actions/assistanceActions";
import { cleanExperiencesPaginatedS, experienceIsLoadingFinish } from "../../app/actions/experienceActions";
import { cleanFinancialsPaginatedS, financialIsLoadingFinish } from "../../app/actions/financialActions";
import { cleanInnovationsPaginatedS, innovationIsLoadingFinish } from "../../app/actions/innovationActions";
import { cleanRegulationsPaginatedS, regulationIsLoadingFinish } from "../../app/actions/regulationActions";
import { startLoadingCatalogsAll } from "../../app/actions/catalogActions";
import { startLoadingCatalogCiiusAll, startLoadingCatalogCiiusByLevel1 } from "../../app/actions/catalogCiiuActions";
import { startLoadingCatalogInstitutionsAll, startLoadingCatalogInstitutionsByLevel1 } from "../../app/actions/catalogInstitutionActions";
import { startLoadingCatalogModules } from "../../app/actions/catalogModuleActions";
import { startLoadingCatalogPhasesByLevel1 } from "../../app/actions/catalogPhaseActions";
import { startLoadingCatalogSectionsByLevel1 } from "../../app/actions/catalogSectionActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { dispatchModulePaginatedSearch } from "../../app/helpers/moduleSearch.helper";
import "../../resources/css/flexbox-card-grid.css";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import L2ContainerInformation from "./L2ContainerInformation";
import L2InformationSearch from "./L2InformationSearch";
import L2NoResultsComponent from "./L2NoResultsComponent";
import L2SearchTextComponent from "./L2SearchTextComponent";
import ExploreUdemyPanel from "./ExploreUdemyPanel";

const L1SearchScreen = () => {

  debugLogPages(':: L1SearchScreen');

  const dispatch = useDispatch();

  const { totalItemsTechnologyS, isLoadingTechnologies = false } = useSelector((state) => state.technology);
  const { totalItemsAlternativeS, isLoadingAlternatives = false } = useSelector((state) => state.alternative);
  const { totalItemsExperienceS, isLoadingExperiences = false } = useSelector((state) => state.experience);
  const { totalItemsInnovationS, isLoadingInnovations = false } = useSelector((state) => state.innovation);
  const { totalItemsAssistanceS, isLoadingAssistances = false } = useSelector((state) => state.assistance);
  const { totalItemsFinancialS, isLoadingFinancials = false } = useSelector((state) => state.financial);
  const { totalItemsVisionS, isLoadingVisions = false } = useSelector((state) => state.vision);
  const { totalItemsRegulationS, isLoadingRegulations = false } = useSelector((state) => state.regulation);

  const prevParams = useSelector((state) => state.searchHistory);
  const { exploreUdemySearchEnabled } = useSelector((state) => state.configuration);
  const udemySearchOn = String(exploreUdemySearchEnabled) === 'true';

  const [moduleSelected, setModuleSelected] = useState("");
  const [catalogCiiuLevel1Selected, setCatalogCiiuLevel1Selected] = useState("");
  const [catalogsToFilter, setCatalogsToFilter] = useState([]);
  const [indicatorsToFilter, setIndicatorsToFilter] = useState([]);
  const [searchTextState, setSearchTextState] = useState("");
  const [, setExistDataToShow] = useState(false);

  const [groupVisionSelected, setGroupVisionSelected] = useState("");
  const [concernSelected, setConcernSelected] = useState("");

  const [itemsPerPage, setItemsPerPage] = useState(9);

  const [wasSearched, setWasSearched] = useState(false);
  const [lastSearchSubmitted, setLastSearchSubmitted] = useState("");

  useEffect(() => {
    dispatch(technologyIsLoadingFinish());
    dispatch(alternativeIsLoadingFinish());
    dispatch(experienceIsLoadingFinish());
    dispatch(innovationIsLoadingFinish());
    dispatch(assistanceIsLoadingFinish());
    dispatch(financialIsLoadingFinish());
    dispatch(visionIsLoadingFinish());
    dispatch(regulationIsLoadingFinish());

    dispatch(cleanTechnologiesPaginatedS())
    dispatch(cleanAlternativesPaginatedS());
    dispatch(cleanExperiencesPaginatedS());
    dispatch(cleanInnovationsPaginatedS());
    dispatch(cleanAssistancesPaginatedS());
    dispatch(cleanFinancialsPaginatedS());
    dispatch(cleanVisionsPaginatedS());
    dispatch(cleanRegulationsPaginatedS());
    dispatch(startLoadingCatalogsAll());
    dispatch(startLoadingCatalogCiiusAll());
    dispatch(startLoadingCatalogInstitutionsAll());
    dispatch(startLoadingCatalogModules());
    dispatch(startLoadingCatalogCiiusByLevel1(1));
    dispatch(startLoadingCatalogSectionsByLevel1(1));
    dispatch(startLoadingCatalogPhasesByLevel1(1));
    dispatch(startLoadingCatalogInstitutionsByLevel1(1));
    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());

    setWasSearched(false);

  }, []);

  useEffect(() => {

    let isSecondSearch = false;
    let existPreviousSearch = false

    if (prevParams && prevParams.catalogModule && Object.keys(prevParams.catalogModule).length > 0 &&
      (prevParams && prevParams.catalogCiiuLevel1 && Object.keys(prevParams.catalogCiiuLevel1).length > 0 ||
        prevParams && prevParams.groupVision && Object.keys(prevParams.groupVision).length > 0) &&
      prevParams && prevParams.searchText && prevParams.searchText !== "") {
      existPreviousSearch = true;
    }

    if ((existPreviousSearch) &&
      (prevParams && prevParams.catalogsToFilter && prevParams.catalogsToFilter.length > 0 ||
        prevParams && prevParams.indicatorsToFilter && prevParams.indicatorsToFilter.length > 0 ||
        prevParams && prevParams.itemsPerPage && prevParams.itemsPerPage !== 9 ||
        prevParams && prevParams.page && prevParams.page > 0)) {
      isSecondSearch = true;
    }

    if (existPreviousSearch || isSecondSearch) {
      setLastSearchSubmitted(prevParams.searchText);
      setWasSearched(true);
      setModuleSelected(prevParams.catalogModule);
      //setCatalogCiiuLevel1Selected(prevParams.catalogCiiuLevel1);
      setSearchTextState(prevParams.searchText);
      setItemsPerPage(prevParams.itemsPerPage);
      setCatalogsToFilter(prevParams.catalogsToFilter);
      setIndicatorsToFilter(prevParams.indicatorsToFilter);

      // CONDICIÓN DE CONTROL:
        // Si el tamaño en Redux es igual al que ya tengo en el estado local,
        // y el texto es el mismo, NO dispares la búsqueda otra vez.
        //if (prevParams.itemsPerPage === itemsPerPage && prevParams.searchText === searchTextState) {
        //    console.log(":: Padre bloqueó búsqueda duplicada - Ya sincronizado");
        //    return; 
        //}

      if (prevParams && prevParams.catalogCiiuLevel1 && Object.keys(prevParams.catalogCiiuLevel1).length > 0) {
        setCatalogCiiuLevel1Selected(prevParams.catalogCiiuLevel1);
      }

      if (prevParams && prevParams.groupVision && Object.keys(prevParams.groupVision).length > 0) {
        setGroupVisionSelected(prevParams.groupVision);
        setConcernSelected(prevParams.concern)
      }

      const searchParams = {
        searchText: prevParams.searchText,
        moduleKey: prevParams.catalogModule?.key,
        page: prevParams.page,
        itemsPerPage: prevParams.itemsPerPage,
        catalogsToFilter: prevParams.catalogsToFilter,
        indicatorsToFilter: prevParams.indicatorsToFilter,
        codeCiiuLevel1: prevParams.catalogCiiuLevel1?.code || null
      };


      dispatchModulePaginatedSearch(dispatch, searchParams);

    } else {
      //console.log("0000, 6, no existPreviousSearch and no isSecondSearch");
    }

  }, [prevParams, dispatch]);


  useEffect(() => {
    if (moduleSelected && wasSearched) {
      setWasSearched(false);
      setLastSearchSubmitted("");
    }
  }, [moduleSelected && moduleSelected.id]);

  //Totals
  const totals = [
    totalItemsTechnologyS, totalItemsAlternativeS, totalItemsExperienceS,
    totalItemsInnovationS, totalItemsAssistanceS, totalItemsFinancialS,
    totalItemsVisionS, totalItemsRegulationS
  ];

  const hasResults = totals.some(total => total && total > 0);

  //Loading
  const isLoading = !!(
    isLoadingTechnologies ||
    isLoadingAlternatives ||
    isLoadingExperiences ||
    isLoadingInnovations ||
    isLoadingAssistances ||
    isLoadingFinancials ||
    isLoadingVisions ||
    isLoadingRegulations
  );

  //const showNoResults = !hasResults && wasSearched;
  const showNoResults = !hasResults && wasSearched && !isLoadingTechnologies;

  return (
    <div className="contenedorBusquedaTextual">
      <NavbarIconsGenericComponent componentName="EndUserSearchTextScreen" />

      <div className="row filtroBusqueda ajusteTamanio">
        <L2SearchTextComponent
          searchTextState={searchTextState}
          setSearchTextState={setSearchTextState}
          moduleSelected={moduleSelected}
          setModuleSelected={setModuleSelected}
          catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
          setCatalogCiiuLevel1Selected={setCatalogCiiuLevel1Selected}
          setExistDataToShow={setExistDataToShow}
          setCatalogsToFilter={setCatalogsToFilter}
          setIndicatorsToFilter={setIndicatorsToFilter}
          setWasSearched={setWasSearched}
          setLastSearchSubmitted={setLastSearchSubmitted}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          groupVisionSelected={groupVisionSelected}
          setGroupVisionSelected={setGroupVisionSelected}
          concernSelected={concernSelected}
          setConcernSelected={setConcernSelected}


        />
      </div>

      {isLoading ? (
        /* Opcional: Un spinner o texto de cargando */
        <div className="text-center mt-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2">Buscando...</p>
        </div>
      ) : hasResults ? (
        /* CASO 1: HAY RESULTADOS */
        <L2ContainerInformation
          searchTextState={searchTextState}
          catalogsToFilter={catalogsToFilter}
          setCatalogsToFilter={setCatalogsToFilter}
          moduleSelected={moduleSelected}
          setModuleSelected={setModuleSelected}
          catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
          setCatalogCiiuLevel1Selected={setCatalogCiiuLevel1Selected}
          indicatorsToFilter={indicatorsToFilter}
          setIndicatorsToFilter={setIndicatorsToFilter}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          groupVisionSelected={groupVisionSelected}
          setGroupVisionSelected={setGroupVisionSelected}
          concernSelected={concernSelected}
          setConcernSelected={setConcernSelected}
        />
      ) : showNoResults ? (
        <L2NoResultsComponent searchText={lastSearchSubmitted} />
        /* CASO 2: BUSCÓ PERO NO HAY RESULTADOS */

      ) : (
        /* CASO 3: ESTADO INICIAL (SIN BÚSQUEDA) */
        <div>
          <L2InformationSearch />
          {udemySearchOn && <ExploreUdemyPanel />}
        </div>
      )}

    </div>
  );
};

export default L1SearchScreen;
